import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairporttopunecab() {



    const cardData = {

keyword: "Navi Mumbai Airport to Pune Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport to Pune Cab services for one-way trips, round trips, corporate travel, family tours, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, and doorstep pickup from Navi Mumbai Airport, we ensure a smooth, comfortable, and hassle-free travel experience on the Mumbai–Pune Expressway.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most famous hill stations on the Mumbai–Pune route, known for waterfalls, valleys, caves, and scenic monsoon views, making them perfect stopovers during travel."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves near Lonavala, known for their historical architecture and spiritual significance along the Pune highway route."
    },
    {
        title: "Bhaja Caves",
        description:
            "Bhaja Caves are historic rock-cut Buddhist caves featuring ancient carvings and peaceful surroundings, popular among history and culture enthusiasts."
    },
    {
        title: "Pawna Lake",
        description:
            "Pawna Lake is a scenic camping destination near Lonavala offering boating, camping, and beautiful sunset views surrounded by hills."
    },
    {
        title: "Lavasa City",
        description:
            "Lavasa is a planned hill city near Pune known for its lakeside promenade, colorful architecture, and peaceful environment for weekend travel."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort near Pune is a historic Maratha fort offering trekking opportunities and panoramic views of the Sahyadri mountains."
    },
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is a historic fort palace in Pune known for its Maratha heritage, architecture, and cultural importance."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a famous landmark in Pune associated with India’s freedom movement and known for its historical significance and architecture."
    },
    {
        title: "Osho Ashram",
        description:
            "Osho Ashram in Pune is a global meditation center attracting visitors from around the world for peace, meditation, and wellness programs."
    },
    {
        title: "Mulshi Dam",
        description:
            "Mulshi Dam near Pune is a beautiful monsoon destination surrounded by hills and greenery, ideal for nature lovers and weekend trips."
    }
],



services: [
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport Cab offers Mumbai Airport to Pune Cab service for safe, reliable, and comfortable intercity travel between Mumbai Airport (BOM) and Pune. Whether you are travelling for business meetings, family trips, tourism, weekend travel, or emergency transfers, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller. Our professional chauffeurs ensure smooth highway driving via Pune-Mumbai Expressway, timely pickup, luggage assistance, and stress-free journey experience. With 24x7 availability, doorstep airport pickup, transparent pricing, and flexible booking options, we make your Pune travel simple and comfortable."
},
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune Cab Service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for corporate travellers, families, and solo passengers, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai to Pune."
},
{
name: "Mumbai Airport to Pune Taxi Fare",
description: "Mumbai Airport to Pune Taxi Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We offer clear pricing with no hidden charges and flexible one-way and round-trip options for cost-effective intercity travel."
},
{
name: "Mumbai Pune Cab One Way",
description: "Mumbai Pune Cab One Way service provides affordable single-journey travel from Mumbai Airport to Pune without return charges. Mumbai Airport Cab ensures comfortable vehicles, professional drivers, and smooth expressway travel for all passengers."
},
{
name: "Mumbai to Pune Cab from Airport",
description: "Mumbai to Pune Cab from Airport service offers quick pickup from Mumbai Airport directly to Pune city or nearby destinations. Mumbai Airport Cab ensures flight tracking, luggage assistance, and timely departure for hassle-free travel."
},
{
name: "Mumbai International Airport to Pune Cab",
description: "Mumbai International Airport to Pune Cab service provides reliable transportation from international arrivals terminal to Pune. Mumbai Airport Cab ensures punctual pickup, safe driving, and comfortable long-distance travel experience."
},
{
name: "Mumbai to Pune Taxi from Airport",
description: "Mumbai to Pune Taxi from Airport service offers convenient and safe airport-to-city transfers. Mumbai Airport Cab provides clean vehicles, experienced chauffeurs, and smooth expressway rides for stress-free travel."
},
{
name: "Navi Mumbai Airport to Pune Cab",
description: "Navi Mumbai Airport to Pune Cab service ensures reliable intercity travel from Navi Mumbai Airport to Pune. Mumbai Airport Cab provides professional drivers, comfortable vehicles, and timely pickup for smooth journeys."
},
{
name: "Navi Mumbai Airport to Pune Taxi",
description: "Navi Mumbai Airport to Pune Taxi service offers safe and affordable airport-to-Pune transfers with experienced chauffeurs and well-maintained vehicles for comfortable travel."
},
{
name: "Navi Mumbai Airport to Pune Cab Service",
description: "Navi Mumbai Airport to Pune Cab Service provides dependable transportation for passengers travelling from Navi Mumbai Airport to Pune. Mumbai Airport Cab ensures punctuality and comfort for all rides."
},
{
name: "Navi Mumbai Airport to Pune Taxi Service",
description: "Navi Mumbai Airport to Pune Taxi Service ensures safe, reliable, and comfortable intercity transfers with professional chauffeurs and clean AC vehicles."
},
{
name: "Cab from Navi Mumbai Airport to Pune",
description: "Cab from Navi Mumbai Airport to Pune service offers direct pickup and drop with smooth highway travel. Mumbai Airport Cab ensures luggage support, punctual service, and comfortable rides."
},
{
name: "Book Cab from Navi Mumbai Airport to Pune",
description: "Book Cab from Navi Mumbai Airport to Pune service allows quick online booking with instant confirmation. Mumbai Airport Cab provides transparent pricing and 24x7 booking support."
},
{
name: "Online Cab Booking Navi Mumbai Airport to Pune",
description: "Online Cab Booking Navi Mumbai Airport to Pune service enables easy digital reservation for intercity travel. Mumbai Airport Cab ensures fast confirmation and multiple vehicle options."
},
{
name: "Best Cab Navi Mumbai Airport to Pune",
description: "Best Cab Navi Mumbai Airport to Pune service provides premium and reliable transportation with experienced chauffeurs and comfortable vehicles for a smooth journey."
},
{
name: "Cheapest Cab Navi Mumbai Airport to Pune",
description: "Cheapest Cab Navi Mumbai Airport to Pune service offers budget-friendly intercity travel without compromising safety or comfort. Mumbai Airport Cab ensures economical pricing."
},
{
name: "Reliable Taxi Navi Mumbai Airport to Pune",
description: "Reliable Taxi Navi Mumbai Airport to Pune service ensures safe, punctual, and consistent airport-to-Pune transfers with professional chauffeurs."
},
{
name: "Airport Pickup Cab Navi Mumbai to Pune",
description: "Airport Pickup Cab Navi Mumbai to Pune service provides timely pickup from airport and direct transfer to Pune with luggage assistance and smooth travel."
},
{
name: "One Way Cab Navi Mumbai Airport to Pune",
description: "One Way Cab Navi Mumbai Airport to Pune service offers affordable single-trip travel without return charges. Mumbai Airport Cab ensures transparent pricing and comfort."
},
{
name: "Round Trip Cab Navi Mumbai Airport to Pune",
description: "Round Trip Cab Navi Mumbai Airport to Pune service provides complete return journey solutions for business and family travel with flexible scheduling."
},
{
name: "Corporate Cab Navi Mumbai Airport to Pune",
description: "Corporate Cab Navi Mumbai Airport to Pune service is designed for business professionals needing punctual, executive, and reliable intercity transportation."
},
{
name: "Luxury Cab Navi Mumbai Airport to Pune",
description: "Luxury Cab Navi Mumbai Airport to Pune service offers premium vehicles for high-end travel experience with comfort, style, and professional chauffeurs."
},
{
name: "Airport Transfer Navi Mumbai to Pune",
description: "Airport Transfer Navi Mumbai to Pune service provides complete pickup and drop solutions for smooth and reliable intercity travel."
},
{
name: "Innova Crysta Cab Navi Mumbai Airport to Pune",
description: "Innova Crysta Cab Navi Mumbai Airport to Pune service offers spacious and premium travel for families and groups with maximum comfort and luggage space."
}
],

tableData: [
["Mumbai Airport to Pune Cab","Mumbai to Pune Cab Service"],
["Mumbai Airport to Pune Taxi Fare","Mumbai Pune Cab One Way"],
["Mumbai to Pune Cab from Airport","Mumbai International Airport to Pune Cab"],
["Mumbai to Pune Taxi from Airport","Navi Mumbai Airport to Pune Cab"],
["Navi Mumbai Airport to Pune Taxi","Navi Mumbai Airport to Pune Cab Service"],
["Cab from Navi Mumbai Airport to Pune","Book Cab from Navi Mumbai Airport to Pune"],
["Online Cab Booking Navi Mumbai Airport to Pune","Best Cab Navi Mumbai Airport to Pune"],
["Cheapest Cab Navi Mumbai Airport to Pune","Reliable Taxi Navi Mumbai Airport to Pune"],
["One Way Cab Navi Mumbai Airport to Pune","Round Trip Cab Navi Mumbai Airport to Pune"],
["Corporate Cab Navi Mumbai Airport to Pune","Luxury Cab Navi Mumbai Airport to Pune"]
],










whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport to Pune Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport to Pune Cab services for business travelers, corporate professionals, families, students, and tourists seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Direct Airport Pickup Convenience",
        WhyChoosedescription: "Passengers arriving at Navi Mumbai Airport can enjoy seamless door-to-door transportation to Pune without the hassle of changing trains, buses, or multiple travel modes."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travel",
        WhyChoosedescription: "Pune is a major IT, industrial, and educational hub, making our airport cab service ideal for executives, employees, entrepreneurs, and corporate visitors."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, return journey, same-day travel, or customized travel package, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Flight Tracking and Timely Pickup",
        WhyChoosedescription: "Our team monitors flight schedules and adjusts pickup timings accordingly, ensuring a smooth airport transfer experience even during flight delays."
    },
    {
        WhyChooseheading: "Experienced Drivers for Expressway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on the Mumbai-Pune Expressway and ensure safe, comfortable, and efficient transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From solo travelers and families to corporate teams and tourist groups, we provide suitable vehicles for every airport transfer requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai Airport to Pune Cabs?",
        answer: "Many travelers prefer direct cab transportation from Navi Mumbai Airport to Pune for convenience, comfort, time savings, and hassle-free travel."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai Airport to Pune?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai Airport to Pune travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Do you provide airport pickup from all terminals?",
        answer: "Yes, pickup services are available from all operational terminals at Navi Mumbai Airport."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many executives, IT professionals, business owners, and corporate employees use our airport cab services regularly."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, and tourist groups."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual flight arrivals."
    },
    {
        question: "Can I get dropped anywhere in Pune?",
        answer: "Yes, drop services are available across Pune including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Magarpatta, PCMC, and nearby areas."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai Airport to Pune travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel arrangements."
    },
    {
        question: "How can I book a Navi Mumbai Airport to Pune Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Kulkarni",
        feedback:
            "After arriving at Navi Mumbai Airport, our cab to Pune was ready on time. The vehicle was comfortable, the driver was courteous, and the journey via Expressway was smooth.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Mehendale",
        feedback:
            "We booked an airport transfer for our family from Navi Mumbai Airport to Pune. The cab was spacious, clean, and the service was exceptionally professional from start to finish.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport to Pune Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-airport-to-pune-cab.jpg",
"description": "Book Navi Mumbai Airport to Pune cab service for reliable airport transfer and outstation travel. Mumbai Airport Cabs offers safe, comfortable, and timely taxi service with professional drivers, one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-to-pune-cab"
}
};







    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport to Pune Cab | Airport Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport to Pune cab for safe and comfortable airport transfer. Reliable taxi service with professional drivers, one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai airport to pune cab, navi mumbai airport to pune taxi, mumbai airport to pune cab service, mumbai airport to pune taxi fare, mumbai pune cab one way, navi mumbai airport to pune cab service, navi mumbai airport to pune taxi service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairporttopunecab;